module.exports = __webpack_public_path__ + "static/img/theme7.4a3ae19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme7.jpg
// module id = QkPz
// module chunks = 1